import { createSlice } from '@reduxjs/toolkit';
import { PartnerListItem, SyncRequestItem, SyncRequestDetail, SyncDataFromPartnerResponse, SyncDataPartnerByIdResponse, DeleteSyncRequestsResponse } from '@store/actions/partnerActions';

interface PartnerState {
    partnerList: { results: PartnerListItem[]; count: number };
    partnerOptions: PartnerListItem[];
    partnerCreation: PartnerListItem | Record<string, never>;
    syncRequestList: { results: SyncRequestItem[]; count: number; page_size: number };
    syncRequestDetail: SyncRequestDetail | null;
    syncDataResult: SyncDataFromPartnerResponse | null;
    syncByIdResult: SyncDataPartnerByIdResponse | null;
    deleteRequestsResult: DeleteSyncRequestsResponse | null;
    loadingSyncRequest: boolean;
    loadingSyncData: boolean;
    loadingSyncById: boolean;
    loadingDeleteRequests: boolean;
    loading: boolean;
    success: boolean;
}

const initialState: PartnerState = {
    partnerList: { results: [], count: 0 },
    partnerOptions: [],
    partnerCreation: {},
    syncRequestList: { results: [], count: 0, page_size: 10 },
    syncRequestDetail: null,
    syncDataResult: null,
    syncByIdResult: null,
    deleteRequestsResult: null,
    loadingSyncRequest: false,
    loadingSyncData: false,
    loadingSyncById: false,
    loadingDeleteRequests: false,
    loading: false,
    success: false,
};

const partnerSlice = createSlice({
    name: 'partner',
    initialState,
    reducers: {
        setPartnerList(state, action) {
            state.partnerList = action.payload;
        },
        setPartnerOptions(state, action) {
            state.partnerOptions = action.payload;
        },
        setPartnerCreation(state, action) {
            state.partnerCreation = action.payload;
        },
        clearPartnerData(state) {
            state.partnerCreation = {};
            state.success = false;
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSuccess(state, action) {
            state.success = action.payload;
        },
        setSyncRequestList(state, action) {
            state.syncRequestList = action.payload;
        },
        setSyncRequestDetail(state, action) {
            state.syncRequestDetail = action.payload;
        },
        setLoadingSyncRequest(state, action) {
            state.loadingSyncRequest = action.payload;
        },
        setSyncDataResult(state, action) {
            state.syncDataResult = action.payload;
        },
        setLoadingSyncData(state, action) {
            state.loadingSyncData = action.payload;
        },
        setSyncByIdResult(state, action) {
            state.syncByIdResult = action.payload;
        },
        setLoadingSyncById(state, action) {
            state.loadingSyncById = action.payload;
        },
        setDeleteRequestsResult(state, action) {
            state.deleteRequestsResult = action.payload;
        },
        setLoadingDeleteRequests(state, action) {
            state.loadingDeleteRequests = action.payload;
        },
    },
});

export const {
    setPartnerList,
    setPartnerOptions,
    setPartnerCreation,
    clearPartnerData,
    setLoading,
    setSuccess,
    setSyncRequestList,
    setSyncRequestDetail,
    setLoadingSyncRequest,
    setSyncDataResult,
    setLoadingSyncData,
    setSyncByIdResult,
    setLoadingSyncById,
    setDeleteRequestsResult,
    setLoadingDeleteRequests,
} = partnerSlice.actions;

export default partnerSlice.reducer;
